const MAX_DECIMALS = 4;

export const formatCoordinateInput = (value: string): string => {
  const matchMaxDecimals = new RegExp(`^-?\\d+(\\.\\d{0,${MAX_DECIMALS}})?$`);
  if (value && !matchMaxDecimals.test(value)) {
    return Number(value).toFixed(MAX_DECIMALS);
  }

  return value;
};
